<!--
 * @Description  : 考核记录页面
 * @Author       : 王帅
 * @Date         : 2024-07-18 10:07:38
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-10-15 11:42:41
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\evaluate-system\EvaluateRecords.vue
-->
<template>
	<div class="operation-layout" :class="{ pd0: !routeQuery }">
		<!-- 列表查询页 -->
		<filter-layout @search="searchResult" @reset="resetSerach" v-if="!routeQuery" hasMore>
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="120px">
					<el-form-item label="考核项目：">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.objName"> </el-input>
					</el-form-item>
					<el-form-item label="考核人：">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.judger"> </el-input>
					</el-form-item>
					<el-form-item label="被考核人：">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.beJudger"> </el-input>
					</el-form-item>
					<el-form-item label="业务来源：">
						<el-select v-model="searchForm.source" placeholder="请选择">
							<el-option
								v-for="(item, index) in yyyw"
								:key="index"
								:label="item.sname"
								:value="item.value"
								:disabled="item.disabled"
							></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #more>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="120px">
					<el-form-item label="考核结果：">
						<el-select v-model="searchForm.markResult" placeholder="请选择">
							<el-option label="差评" value="0"></el-option>
							<el-option label="良好" value="1"></el-option>
							<el-option label="优秀" value="2"></el-option>
							<el-option label="完美" value="3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="申请时间" prop="dateArr" class="date-time">
						<el-date-picker
							v-model="searchForm.evaTime"
							type="daterange"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						>
						</el-date-picker>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="operation-main">
					<div class="operation-header">
						<div class="title">
							合计考核记录： <span class="blue">{{ total }}</span> 条
						</div>
						<div class="btnGroups"></div>
					</div>
					<div class="operation-container w-table-layout w-table-page">
						<div class="w-table-content" v-show="tableShow">
							<el-table ref="xTable" :data="filterData" height="100%" highlight-current-row border>
								<el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
								<el-table-column prop="serialNo" label="流水号" align="center" width="120" show-overflow-tooltip></el-table-column>
								<el-table-column
									prop="createDate"
									label="考核时间"
									align="center"
									width="140"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column prop="judger" label="考核人" align="center" width="100" show-overflow-tooltip></el-table-column>
								<el-table-column
									prop="judgeRoleName"
									label="考核人角色"
									align="center"
									width="100"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column prop="judgeType" label="考核人主体类型" align="center" width="120" show-overflow-tooltip>
									<template slot-scope="scope">
										<span v-if="scope.row.judgeType == 0">个人</span>
										<span v-else-if="scope.row.judgeType == 1">企业</span>
									</template>
								</el-table-column>
								<el-table-column
									prop="beJudger"
									label="被考核人"
									align="center"
									min-width="100"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column
									prop="beJudgeRoleName"
									label="被考核人角色"
									align="center"
									min-width="140"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column prop="beJudgeType" label="被考核人主体类型" align="center" width="140" show-overflow-tooltip>
									<template slot-scope="scope">
										<span v-if="scope.row.beJudgeType == 0">个人</span>
										<span v-else-if="scope.row.beJudgeType == 1">企业</span>
									</template></el-table-column
								>
								<el-table-column
									prop="markObjName"
									label="考核对象"
									align="center"
									min-width="120"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column prop="objName" label="考核项目" align="center" width="160" show-overflow-tooltip></el-table-column>
								<el-table-column
									prop="sourceName"
									label="业务来源"
									align="center"
									width="100"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column prop="markResult" label="考核结果" align="center" width="100" show-overflow-tooltip>
									<template slot-scope="scope">
										<span v-if="scope.row.markResult == 0">差评</span>
										<span v-else-if="scope.row.markResult == 1">良好</span>
										<span v-else-if="scope.row.markResult == 2">优秀</span>
										<span v-else-if="scope.row.markResult == 3">完美</span>
									</template></el-table-column
								>
								<el-table-column prop="score" label="分值" align="center" width="80" show-overflow-tooltip></el-table-column>
								<el-table-column align="center" width="100">
									<template slot="header">操作</template>
									<template slot-scope="scope">
										<el-button type="primary" size="small" round plain class="table-btn" @click="getDetail(scope.row)">
											<svg-icon icon-class="form-details"></svg-icon> 详情
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="w-table-footer">
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="currentPage"
								:page-sizes="pageList"
								:page-size="pageSize"
								:total="total"
								layout="total, sizes, prev, pager, next, jumper"
							>
							</el-pagination>
						</div>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 详情页 -->
		<template v-else>
			<RecordsDetail></RecordsDetail>
		</template>
	</div>
</template>

<script>
import { getRecordsData } from 'api/modules/evaluate-system/EvaluateRecords'
import { mapState } from 'vuex'
import RecordsDetail from './RecordsDetail'
import { dateFormat } from 'utils/tools'
export default {
	name: 'Evaluate-records',
	components: {
		RecordsDetail
	},
	data() {
		return {
			filterData: [],
			searchForm: {
				objName: '',
				judger: '',
				beJudger: '',
				source: '',
				markResult: '',
				evaTime: [],
				startTime: '',
				endTime: ''
			},
			loading: false,
			//筛选框
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			searchToggle: true,
			tableShow: true
		}
	},

	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('searchForm')) {
				this.searchForm = JSON.parse(this.$getSessionItem('searchForm'))

				// 移除 避免污染
				this.$removeSessionItem('searchForm')
			}

			if (this.$getSessionItem('currentPage')) {
				this.currentPage = JSON.parse(this.$getSessionItem('currentPage'))

				// 移除 避免污染
				this.$removeSessionItem('currentPage')
			}

			if (this.$getSessionItem('pageSize')) {
				this.pageSize = JSON.parse(this.$getSessionItem('pageSize'))

				// 移除 避免污染
				this.$removeSessionItem('pageSize')
			}
			if (this.$getSessionItem('detailData')) {
				// 移除 避免污染
				this.$removeSessionItem('detailData')
			}
		}
		this.getData()
	},
	methods: {
		//获得列表数据
		getData() {
			if (this.searchForm.evaTime && this.searchForm.evaTime.length > 0) {
				this.searchForm.startDate = this.searchForm.evaTime[0] + ' 00:00:00'
				this.searchForm.endDate = this.searchForm.evaTime[1] + ' 23:59:59'
			} else {
				this.searchForm.startDate = ''
				this.searchForm.endDate = ''
			}
			let params = Object.assign({}, this.searchForm)
			this.loading = true
			// 分页参数
			params.current = this.currentPage
			params.size = this.pageSize
			getRecordsData(params)
				.then((res) => {
					this.loading = false
					this.filterData = res.data.operateMarkRecordPage.records
					this.currentPage = parseInt(res.data.operateMarkRecordPage.current)
					this.total = parseInt(res.data.operateMarkRecordPage.total)
					this.pageSize = parseInt(res.data.operateMarkRecordPage.size)
					// 设置回显
					this.setChecked()
				})
				.catch((err) => {
					this.loading = false
				})
		},

		//查看明细
		getDetail(params) {
			this.detailData = params

			// 存值
			this.$setSessionItem('searchForm', JSON.stringify(this.searchForm))
			this.$setSessionItem('currentPage', JSON.stringify(this.currentPage))
			this.$setSessionItem('pageSize', JSON.stringify(this.pageSize))

			// 数据
			this.$setSessionItem('detailData', JSON.stringify(params))

			this.$router.push({
				path: '/evaluate-records',
				query: {
					type: 'detail',
					id: params.id
				}
			})
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.getData()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getData()
		},

		// 是否展开搜索区域
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		// 搜索
		searchResult() {
			this.currentPage = 1
			this.pageSize = 10
			this.getData()
		},

		//重置筛选框
		resetSerach() {
			this.currentPage = 1
			this.pageSize = 10
			this.searchForm = {
				evaTime: []
			}
			this.getData()
		}
	},

	computed: {
		...mapState('app', { isBack: (state) => state.isBack }),
		routeQuery() {
			return this.$route.query.type
		},
		...mapState('dict', {
			yyyw: (state) => state.yyyw
		})
	},

	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
			setTimeout(() => {
				this.$refs.xTable.doLayout()
			}, 1000)
		}
	}
}
</script>

<style lang="less" scoped>
.operation-layout {
	padding: 0 8px;
	.search {
		border-bottom: 1px solid #2672cc;
		padding: 5px 0;
	}
	.mt4 {
		margin-top: 4px;
	}
	.cmain {
		height: 100%;
		overflow-y: auto;
	}
}
</style>
